// extracted by mini-css-extract-plugin
export default {"root":"NavigationButtons_root__YHlf8"};